import facts from './modules/facts';
import fancybox from './modules/fancybox';
import filterevent from './modules/filterevent';
import forms from './modules/forms';
import grid from './modules/grid';
import morecontent from './modules/morecontent';
import navigation from './modules/navigation';
import news from './modules/news';
import newspagination from './modules/newspagination';
import objectfit from './polyfill/object-fit';
import onpagenav from './modules/onpagenav';
import parsley from './modules/parsley';
import quickcontact from './modules/quickcontact';
import quiz from './modules/quiz';
import searchresultfacets from './modules/searchresultfacets';
import slider from './modules/slider';
import stickysidebar from './modules/stickysidebar';
import blog from './modules/blog';
import backgroundimage from './helpers/backgroundimage';
import whistleblower from './modules/whistleblower';

$(() => {
    facts();
    fancybox();
    filterevent();
    forms();
    morecontent();
    navigation();
    news();
    newspagination();
    onpagenav();
    parsley();
    quickcontact();
    quiz();
    searchresultfacets();
    slider();
    stickysidebar();
    blog();
    backgroundimage();
    whistleblower();

    // polyfill
    objectfit();

    grid(); // function to show grid in frontend
});
